import { render } from "./JobInfoPane.vue?vue&type=template&id=2d8f5e97"
import script from "./JobInfoPane.vue?vue&type=script&lang=js"
export * from "./JobInfoPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__